import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-shortcut-menu',
  templateUrl: './shortcut-menu.component.html',
  styleUrls: ['./shortcut-menu.component.scss']
})
export class ShortcutMenuComponent implements OnInit {

  @Input() TransactionType: any;
  @Input() ModalType: any;

  constructor() { }

  ngOnInit() {
  }

}
